export default function initEspecificacoes() {
    const accordions = document.querySelectorAll('.c-specs__item');

    if (!accordions.length) return;

    accordions.forEach(accordion => {
        const trigger = accordion.querySelector('.c-specs__trigger');

        trigger.addEventListener('click', (e) => {
            // Impedimos o HTML de abrir/fechar o details instantaneamente
            e.preventDefault();

            // Preparamos o elemento para ser animado
            accordion.style.overflow = 'hidden';
            accordion.style.transition = 'height 0.3s ease-in-out';

            if (!accordion.open) {
                // Fecha os outros que estiverem abertos
                accordions.forEach(other => {
                    if (other !== accordion && other.open) {
                        fecharSuavemente(other);
                    }
                });
                // Abre o clicado
                abrirSuavemente(accordion);
            } else {
                // Se já está aberto, a gente fecha
                fecharSuavemente(accordion);
            }
        });
    });

    // A MÁGICA DA MATEMÁTICA
    function abrirSuavemente(details) {
        const alturaFechado = details.offsetHeight;

        details.open = true; // Abre instantaneamente no DOM
        const alturaAberto = details.offsetHeight; // Mede a nova altura real

        // Volta para a altura fechada para começar a animação
        details.style.height = `${alturaFechado}px`;

        // Força o navegador a recalcular a tela (Reflow)
        details.offsetHeight;

        // Dispara a animação para a altura aberta
        details.style.height = `${alturaAberto}px`;

        // Limpa as propriedades depois que a animação acaba
        details.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'height') {
                details.style.height = '';
                details.removeEventListener('transitionend', handler);
            }
        });
    }

    function fecharSuavemente(details) {
        const alturaAberto = details.offsetHeight;

        details.open = false;
        const alturaFechado = details.offsetHeight;
        details.open = true; // Mantém aberto temporariamente para animar

        details.style.height = `${alturaAberto}px`;
        details.offsetHeight; // Força Reflow
        details.style.height = `${alturaFechado}px`; // Dispara animação
        details.open = false; // Fecha de verdade

        details.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'height') {
                details.style.height = '';
                details.removeEventListener('transitionend', handler);
            }
        });
    }
}